import { useEffect } from "react";
import {useUpdateUserCNumber } from "./useUserProfileQueries";
import {useDriveStore} from "../drive/DriveStore";
import useProfileStore from "./UserProfileStore";

export const CNumberListener = () => {
  const {cNumbers} = useDriveStore();
  const { mutate } = useUpdateUserCNumber();

  const { oktaUserProfile, unifyUserProfile,} = useProfileStore();

  useEffect(() => {
    if (!oktaUserProfile?.lastLogin || !unifyUserProfile?.lastLoggedIn) return;

    const cleaned = unifyUserProfile.lastLoggedIn
      .replace(/^[A-Za-z]+,\s*/, '')
      .replace(/\s+at\s+/g, ', ')
      .replace(/Coordinated Universal Time$/, 'UTC');
    
    const date1 = new Date(cleaned).toISOString();
    const date2 = new Date(oktaUserProfile.lastLogin).toISOString();

    if(cNumbers && cNumbers.length >0 && date1 !== date2){
      mutate({ cNumbers: cNumbers });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [oktaUserProfile?.lastLogin, unifyUserProfile?.lastLoggedIn,cNumbers]);

  return null;
};
